const PREFIX = 'VITE_'

export default (key, defaultValue = undefined) => {
  const name = PREFIX + key
  return import.meta.env[name] || defaultValue
}
